<template>
  <!-- 紧凑型 -->
  <a-space-compact
    v-if="mode !== 'loose'"
    :class="[
      bem.b(),
      bem.is('compact'), // 紧凑型类名
      bem.is(shape === 'round' ? 'btn-round' : 'btn-default'),
      bem.is(useTip ? 'use-tip' : ''),
      bem.is(noBorder ? 'no-border' : ''),
    ]"
    :size="size"
  >
    <!-- 显示可见按钮 -->
    <template
      v-for="(item, index) in visibleItems"
      :key="item.key ? item.key + index : index"
    >
      <a-popconfirm
        v-if="item.enabledPopConfirm"
        v-bind="getPopConfirmProps(item)"
        overlay-class-name="btn-group-popconfirm-wrapper"
        @cancel="item?.popConfirmJson?.onHandleCancel"
        @confirm="item?.popConfirmJson?.onHandleOk"
      >
        <template v-if="item?.popConfirmJson?.icon" #icon>
          <ll-icon
            style="margin-top: 4px"
            :icon-name="`icon-${item.popConfirmJson.icon}`"
            :color="item.popConfirmJson.iconColor"
            :size="item.popConfirmJson.iconSize"
          />
        </template>

        <!-- 文字提示 -->
        <ll-tooltip
          v-if="useTip && showTip && item.label"
          :tip="item.label"
          :is-white-bg="isWhiteBg"
          :arrow="arrow"
          :class="`${disabled || item.disabled ? 'disabled' : ''} ${
            !noBorder && item.type === 'primary' ? 'primary-btn' : ''
          }`"
        >
          <ll-button
            v-bind="filterPopConfirmConfig(item)"
            label=""
            shape="default"
            :ghost="ghost"
            :disabled="disabled || item.disabled"
            :type="noBorder ? 'link' : item.type || 'default'"
            :class="[`btn-${item.key}`]"
            :icon="{ iconName: item.icon }"
            @click="(e) => emits('handle-btn', item, index, e)"
          />
        </ll-tooltip>

        <ll-button
          v-else
          v-bind="filterPopConfirmConfig(item)"
          :label="useTip ? '' : item.label || ''"
          shape="default"
          :ghost="ghost"
          :disabled="disabled || item.disabled"
          :type="noBorder ? 'link' : item.type || 'default'"
          :class="[`btn-${item.key}`]"
          :icon="{ iconName: item.icon }"
          :icon-space="iconSpace"
          @click="(e) => emits('handle-btn', item, index, e)"
        />
      </a-popconfirm>
      <template v-else>
        <!-- 文字提示 -->
        <ll-tooltip
          v-if="useTip && showTip"
          :tip="item.label"
          :is-white-bg="isWhiteBg"
          :arrow="arrow"
          :class="`${disabled || item.disabled ? 'disabled' : ''} ${
            !noBorder && item.type === 'primary' ? 'primary-btn' : ''
          }`"
        >
          <ll-button
            v-bind="filterPopConfirmConfig(item)"
            label=""
            shape="default"
            :ghost="ghost"
            :disabled="disabled || item.disabled"
            :type="noBorder ? 'link' : item.type || 'default'"
            :class="[`btn-${item.key}`]"
            :icon="{ iconName: item.icon }"
            @click="(e) => emits('handle-btn', item, index, e)"
          />
        </ll-tooltip>

        <ll-button
          v-else
          v-bind="filterPopConfirmConfig(item)"
          :label="useTip ? '' : item.label || ''"
          shape="default"
          :ghost="ghost"
          :disabled="disabled || item.disabled"
          :type="noBorder ? 'link' : item.type || 'default'"
          :class="[`btn-${item.key}`]"
          :icon="{ iconName: item.icon }"
          :icon-space="iconSpace"
          @click="(e) => emits('handle-btn', item, index, e)"
        />
      </template>
    </template>

    <!-- 当有隐藏项时显示下拉菜单 -->
    <a-dropdown v-if="hiddenItems.length > 0" :trigger="moreTrigger">
      <ll-tooltip
        v-if="useTip && showTip && moreText"
        :tip="moreText"
        :is-white-bg="isWhiteBg"
        :arrow="arrow"
        :class="`${
          !noBorder && props.moreType === 'primary' ? 'primary-btn' : ''
        }`"
      >
        <ll-button
          :ghost="ghost"
          :disabled="disabled"
          :type="noBorder ? 'link' : props.moreType || 'default'"
          label=""
          :icon="{ iconName: moreIcon }"
        />
      </ll-tooltip>

      <ll-button
        v-else
        :label="useTip ? '' : moreText || ''"
        :ghost="ghost"
        :disabled="disabled"
        :type="noBorder ? 'link' : props.moreType || 'default'"
        :icon="{ iconName: moreIcon }"
        :icon-space="iconSpace"
        :icon-direction="moreIconDirection"
      />

      <template #overlay>
        <a-menu>
          <a-menu-item
            v-for="(hiddenItem, idx) in hiddenItems"
            :key="`hidden-${idx}`"
            :disabled="disabled || hiddenItem.disabled"
            @click="(e) => emits('handle-btn', hiddenItem, idx, e)"
          >
            <a-popconfirm
              v-if="hiddenItem.enabledPopConfirm"
              overlay-class-name="btn-group-popconfirm-wrapper"
              v-bind="getPopConfirmProps(hiddenItem)"
              @cancel="hiddenItem?.popConfirmJson?.onHandleCancel"
              @confirm="hiddenItem?.popConfirmJson?.onHandleOk"
            >
              <template v-if="hiddenItem?.popConfirmJson?.icon" #icon>
                <ll-icon
                  style="margin-top: 4px"
                  :icon-name="`icon-${hiddenItem.popConfirmJson.icon}`"
                  :color="hiddenItem.popConfirmJson.iconColor"
                  :size="hiddenItem.popConfirmJson.iconSize"
                />
              </template>
              <div class="btn-group-more-menu-item">
                <ll-icon :icon-name="hiddenItem.icon" />
                {{ hiddenItem.label }}
              </div>
            </a-popconfirm>
            <div v-else class="btn-group-more-menu-item">
              <ll-icon :icon-name="hiddenItem.icon" />
              {{ hiddenItem.label }}
            </div>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </a-space-compact>

  <!-- 宽松型 -->
  <a-space v-else :size="spaceSize" :class="[bem.b(), bem.is('loose')]">
    <template
      v-for="(item, index) in visibleItems"
      :key="item.key ? item.key + index : index"
    >
      <a-popconfirm
        v-if="item.enabledPopConfirm"
        v-bind="getPopConfirmProps(item)"
        overlay-class-name="btn-group-popconfirm-wrapper"
        @cancel="item?.popConfirmJson?.onHandleCancel"
        @confirm="item?.popConfirmJson?.onHandleOk"
      >
        <template v-if="item?.popConfirmJson?.icon" #icon>
          <ll-icon
            style="margin-top: 4px"
            :icon-name="`icon-${item.popConfirmJson.icon}`"
            :color="item.popConfirmJson.iconColor"
            :size="item.popConfirmJson.iconSize"
          />
        </template>

        <!-- 文字提示 -->
        <ll-tooltip
          v-if="useTip && item.label"
          :tip="item.label"
          :is-white-bg="isWhiteBg"
          :arrow="arrow"
        >
          <ll-button
            v-bind="filterPopConfirmConfig(item)"
            label=""
            :ghost="ghost"
            :size="size"
            :disabled="disabled || item.disabled"
            :type="item.type || 'default'"
            :class="`btn-${item.key}`"
            :icon="{ iconName: item.icon }"
            @click="(e) => emits('handle-btn', item, index, e)"
          />
        </ll-tooltip>
        <ll-button
          v-else
          v-bind="filterPopConfirmConfig(item)"
          :label="useTip ? '' : item.label || ''"
          :ghost="ghost"
          :size="size"
          :disabled="disabled || item.disabled"
          :type="item.type || 'default'"
          :class="`btn-${item.key}`"
          :icon="{ iconName: item.icon }"
          :icon-space="iconSpace"
          @click="(e) => emits('handle-btn', item, index, e)"
        />
      </a-popconfirm>
      <template v-else>
        <!-- 文字提示 -->
        <ll-tooltip
          v-if="useTip && item.label"
          :tip="item.label"
          :is-white-bg="isWhiteBg"
          :arrow="arrow"
        >
          <ll-button
            v-bind="filterPopConfirmConfig(item)"
            label=""
            :ghost="ghost"
            :size="size"
            :disabled="disabled || item.disabled"
            :type="item.type || 'default'"
            :class="`btn-${item.key}`"
            :icon="{ iconName: item.icon }"
            @click="(e) => emits('handle-btn', item, index, e)"
          />
        </ll-tooltip>
        <ll-button
          v-else
          v-bind="filterPopConfirmConfig(item)"
          :label="useTip ? '' : item.label || ''"
          :ghost="ghost"
          :size="size"
          :disabled="disabled || item.disabled"
          :type="item.type || 'default'"
          :class="`btn-${item.key}`"
          :icon="{ iconName: item.icon }"
          :icon-space="iconSpace"
          @click="(e) => emits('handle-btn', item, index, e)"
        />
      </template>
    </template>

    <!-- 当有隐藏项时显示下拉菜单 -->
    <a-dropdown v-if="hiddenItems.length > 0" :trigger="moreTrigger">
      <!-- 文字提示 -->
      <!-- 更多 -->
      <ll-tooltip
        v-if="useTip && moreText"
        :tip="moreText"
        :is-white-bg="isWhiteBg"
        :arrow="arrow"
      >
        <ll-button
          :ghost="ghost"
          :shape="moreShape"
          :disabled="disabled"
          :type="props.moreType || 'default'"
          :size="size"
          :icon="{ iconName: moreIcon }"
        />
      </ll-tooltip>

      <ll-button
        v-else
        :label="useTip ? '' : moreText || ''"
        :ghost="ghost"
        :disabled="disabled"
        :shape="moreShape"
        :type="props.moreType || 'default'"
        :size="size"
        :icon="{ iconName: moreIcon }"
        :icon-direction="moreIconDirection"
        :icon-space="iconSpace"
      />
      <template #overlay>
        <a-menu>
          <a-menu-item
            v-for="(hiddenItem, idx) in hiddenItems"
            :key="`hidden-${idx}`"
            :disabled="disabled || hiddenItem.disabled"
            @click="(e) => emits('handle-btn', hiddenItem, idx, e)"
          >
            <a-popconfirm
              v-if="hiddenItem.enabledPopConfirm"
              v-bind="getPopConfirmProps(hiddenItem)"
              overlay-class-name="btn-group-popconfirm-wrapper"
              @cancel="hiddenItem?.popConfirmJson?.onHandleCancel"
              @confirm="hiddenItem?.popConfirmJson?.onHandleOk"
            >
              <template v-if="hiddenItem?.popConfirmJson?.icon" #icon>
                <ll-icon
                  style="margin-top: 4px"
                  :icon-name="`icon-${hiddenItem.popConfirmJson.icon}`"
                  :color="hiddenItem.popConfirmJson.iconColor"
                  :size="hiddenItem.popConfirmJson.iconSize"
                />
              </template>
              <div class="btn-group-more-menu-item">
                <ll-icon :icon-name="hiddenItem.icon" />
                {{ hiddenItem.label }}
              </div>
            </a-popconfirm>
            <div v-else class="btn-group-more-menu-item">
              <ll-icon :icon-name="hiddenItem.icon" />
              {{ hiddenItem.label }}
            </div>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </a-space>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { computed } from 'vue'
import { buttonGroupProps } from './button'

defineOptions({ name: 'LlButtonGroup' })

const bem = createNamespace('button-group')

const props = defineProps(buttonGroupProps)
const emits = defineEmits(['handle-btn'])

const newItems = computed(() => {
  return props.items.filter((item) => !item.hidden)
})

// 计算可见按钮项
const visibleItems = computed(() => {
  if (props.maxCount <= 0 || props.maxCount >= newItems.value.length) {
    return newItems.value
  }
  // 留出一个位置给"更多"下拉按钮
  return newItems.value.slice(0, props.maxCount - 1)
})

// 计算隐藏按钮项
const hiddenItems = computed(() => {
  if (props.maxCount <= 0 || props.maxCount >= newItems.value.length) {
    return []
  }
  return newItems.value.slice(props.maxCount - 1)
})

// 获取确认气泡框属性
const getPopConfirmProps = computed(() => {
  return (item) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { onHandleCancel, onHandleOk, title, icon, ...rest } =
      item.popConfirmJson || {}
    return {
      ...rest,
      title: title || '确定删除吗？',
    }
  }
})

// 过滤多余气泡框属性
const filterPopConfirmConfig = computed(() => {
  return (item) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { enabledPopConfirm, popConfirmJson, ...rest } = item
    return {
      ...rest,
    }
  }
})
</script>
